// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as Sentry from '@sentry/react';
import { getCurrentUser } from '@/authentication/api/get-current-user';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    await context.queryClient.ensureQueryData({
      queryKey: ['current-user'],
      queryFn: async () => {
        const { user } = await getCurrentUser();

        Sentry.setUser({ id: user.id, email: user.email });

        return user;
      },
    });

    // Redirect to the assets page if the user is logged in. The TanStack
    // documentation recommends throwing the result of the 'redirect' function
    // to redirect the user. Typically only errors should be thrown, but this
    // is the recommended approach by TanStack.
    //
    // https://tanstack.com/router/latest/docs/framework/react/guide/authenticated-routes#redirecting
    //
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/dashboard/asset' });
  },
});
